import { useEffect, useState } from "react";
import { Card } from "./../../components/card/card.jsx";
import { Link } from "react-router-dom";
import { dataMentoringList } from "../../config/apiSPA.js";
import Pagination2 from "../../components/pagination/pagination2.jsx";
import DateFormat from "../../components/dateFormater/dateFormat1.js";
import Pagination3 from "../../components/pagination/pagination3.jsx";

const trainingPresetData = {
  links: {},
  meta: {},
  data: [],
};

function DataMentoring() {
  const [mentoringAll, setMentoringAll] = useState(trainingPresetData);
  const [search1Value, setSearch1Value] = useState("");

  function nextClick1() {
    if (mentoringAll.meta.current_page < mentoringAll.meta.last_page) dataMentoringList(search1Value, mentoringAll.meta.current_page + 1).then((res) => setMentoringAll(res));
  }
  function prevClick1() {
    if (mentoringAll.meta.current_page > 0) dataMentoringList(search1Value, mentoringAll.meta.current_page - 1).then((res) => setMentoringAll(res));
  }
  function submitSearch1(e) {
    e.preventDefault();
    dataMentoringList(search1Value).then((res) => setMentoringAll(res));
  }

  useEffect(() => {
    dataMentoringList().then((res) => {
      setMentoringAll(res);
    });
  }, []);

  return (
    <>
      <div>
        <div className="d-flex align-items-center mb-3">
          <div>
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <a href="#/">MENTORING</a>
              </li>
              <li className="breadcrumb-item active">Data</li>
            </ul>

            <h1 className="page-header">
              Mentoring Data <small></small>
            </h1>
          </div>

          <div className="ms-auto">
            <Link to="/mentoring/report/event" className="btn btn-outline-theme">
              <i className="fa fa-plus-circle fa-fw me-1"></i> Add Mentoring
            </Link>
          </div>
        </div>

        <hr className="mb-4" />

        <Card>
          <div className="tab-content p-4">
            {/* ----------------All Tab------------------------------------------------------------------ */}
            <div className="tab-pane fade show active" id="allTab">
              <form onSubmit={(e) => submitSearch1(e)}>
                <div className="input-group mb-4">
                  <div className="d-flex justify-content-end">
                    <div className="input-group">
                      <input type="text" onChange={(e) => setSearch1Value(e.target.value)} className="form-control px-35px" placeholder="Search" />
                      <div className="input-group-text position-absolute top-0 bottom-0 bg-none border-0 start-0" style={{ zIndex: 1020 }}>
                        <i className="fa fa-search opacity-5"></i>
                      </div>
                    </div>
                  </div>
                  <button className="btn btn-outline-default" type="submit">
                    <i className="fas fa-search"></i>
                  </button>
                </div>
              </form>

              {/* ----------------Table-------------- */}

              <div className="table-responsive">
                <table className="table table-hover text-nowrap">
                  <thead>
                    <tr>
                      <th className="border-top-0 pt-0 pb-2">NRP</th>
                      <th className="border-top-0 pt-0 pb-2">Name</th>
                      <th className="border-top-0 pt-0 pb-2">Sub-Section</th>
                      <th className="border-top-0 pt-0 pb-2">Competency</th>
                      <th className="border-top-0 pt-0 pb-2">Date</th>
                      <th className="border-top-0 pt-0 pb-2">Instructor</th>
                      <th className="border-top-0 pt-0 pb-2">Type</th>
                    </tr>
                  </thead>
                  <tbody>
                    {mentoringAll.data.length > 0 ? (
                      mentoringAll.data.map((value, index) => (
                        <tr key={index}>
                          <td className="align-middle">
                            <Link to={"/manpower/detail/" + value.manpower.id}>{value.manpower.nrp}</Link>
                          </td>
                          <td className="align-middle">{value.manpower.nama}</td>
                          <td className="align-middle">{value.manpower.subSection}</td>
                          <td className="align-middle">{value.kodeComp?.namaKompetensi ?? "-"}</td>
                          <td className="align-middle">{DateFormat(value.startDate)}</td>
                          <td className="align-middle">{value.instructor.namaInstructor}</td>
                          <td className="align-middle">{value.activity?.name ?? "-"}</td>
                          <td className="align-middle">
                            <Link className="btn btn-outline-theme" to={"/mentoring/detail/" + value.id}>
                              ...
                            </Link>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td className="align-middle">no Data</td>
                        <td className="align-middle"></td>
                        <td className="align-middle"></td>
                        <td className="align-middle"></td>
                        <td className="align-middle"></td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              {/* ----------------End Table-------------- */}
              {mentoringAll ? <Pagination3 pageInfo={mentoringAll} nextClick={nextClick1} prevClick={prevClick1} /> : ""}
            </div>
            {/* ----------------End All Tab------------------------------------------------------------------ */}
          </div>
        </Card>
      </div>
    </>
  );
}

export default DataMentoring;
